import {
    post,
    get,
    del,
} from '../utils/request';


// 获取微信jssdk签名
export const getJssdkSingature = params => post('/wxJsapiSignature', params);
// 捐赠
export const donate = params => post('/wx/order/book', params);
// 支付成功
export const reportPaySuccess = params => get(`/wx/pay/changePayStatus2Paying/${params.orderNo}`);
// 根据orderNo查询证书
export const getCertByOrderNo = params => get(`/wx/certificate/findByOrderNo/${params.orderNo}`);
// 查询证书
export const queryCertList = params => get('/wx/certificate/query', params);
// pages/index.vue中， 金额选择列表，和随机选择列表， 对应的字段为， chooseList， randomList
export const queryPayConfig = () => get('/wx/pay/config', undefined);



// WEBPACK FOOTER //
// ./src/apis/index.js